import { useState, useEffect } from 'react';

const MessageComponent = ({ message, title, type = 'info', position = 'top-right', autoHide = true, autoHideDelayMs = 3000, isVisible = false, onClose }) => {
  const [visible, setVisible] = useState(isVisible);

  useEffect(() => {
    setVisible(isVisible);
    
    if (isVisible && autoHide) {
      const timer = setTimeout(() => {
        setVisible(false);
        if (onClose) onClose();
      }, autoHideDelayMs);
      
      return () => clearTimeout(timer);
    }
  }, [isVisible, autoHide, autoHideDelayMs, onClose]);

  if (!visible || !message) return null;

  const typeClasses = {
    success: 'bg-success-light text-success',
    error: 'bg-danger-light text-danger',
    warning: 'bg-warning-light text-warning',
    info: 'bg-info-light text-info',
  };

  const positionClasses = {
    'top-right': { top: 'var(--sp-4)', right: 'var(--sp-4)' },
    'top-left': { top: 'var(--sp-4)', left: 'var(--sp-4)' },
    'bottom-right': { bottom: 'var(--sp-4)', right: 'var(--sp-4)' },
    'bottom-left': { bottom: 'var(--sp-4)', left: 'var(--sp-4)' },
  };

  return (
    <div
      className={`message-component ${typeClasses[type] || ''}`}
      style={{
        position: 'fixed',
        ...positionClasses[position],
        padding: 'var(--sp-4)',
        borderRadius: 'var(--r-md)',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        zIndex: 'var(--z-modal)',
        maxWidth: '400px',
      }}
    >
      {title && <div style={{ fontWeight: 700, marginBottom: 'var(--sp-2)' }}>{title}</div>}
      <div>{message}</div>
      <button
        onClick={() => {
          setVisible(false);
          if (onClose) onClose();
        }}
        style={{
          position: 'absolute',
          top: 'var(--sp-2)',
          right: 'var(--sp-2)',
          background: 'transparent',
          border: 'none',
          cursor: 'pointer',
          fontSize: '18px',
        }}
      >
        ×
      </button>
    </div>
  );
};

export default MessageComponent;
